module.exports = __webpack_public_path__ + "static/media/green.6be8aabe.svg";